import { render } from "./LightLatexMarkdownRender.vue?vue&type=template&id=67816cc7&scoped=true"
import script from "./LightLatexMarkdownRender.vue?vue&type=script&lang=js"
export * from "./LightLatexMarkdownRender.vue?vue&type=script&lang=js"

import "./LightLatexMarkdownRender.vue?vue&type=style&index=0&id=67816cc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67816cc7"]])

export default __exports__